import React, { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import LoadingButton from '@mui/lab/LoadingButton';
import CancelIcon from '@mui/icons-material/Cancel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ConfirmDialog from './confirm.dialog';

import GoogleSheetsService from '../service/googlesheet.service';

const PlayerForm = ({ updatePlayer, player, isBlueTeeAvailable, enableCancel, competitionId, updateValidation, transportFull, transportEnabled }) => {
    const [cancelling, setCancelling] = useState(false);
    const [confirmCancelOpen, setConfirmCancelOpen] = useState(false);

    const cancelRegistration = () => {
        updateValidation('', '');
        setConfirmCancelOpen(false);
        setCancelling(true);
        GoogleSheetsService.cancelRegistration(1, competitionId, player.registrationNumber, player.name).then((success) => {
            setCancelling(false);
            if (success === true) {
                updatePlayer({ ...player, status: 4 });
                updateValidation(`${player.name} är nu avbokad från tävlingen!`, '');
            } else {
                updateValidation('', 'Tävlingen börjar snart! Du kan tyvärr inte längre avboka eller ändra på din bokning');
            }
        });
    }

    return (
        <div className='s4g-section'>
            <div className='s4g-player-form'>
                <div className='s4g-player-name-info'>
                    {enableCancel === true && <div className='pr-3'>
                        <LoadingButton
                            loading={cancelling}
                            variant="outlined"
                            loadingPosition="start"
                            startIcon={<CancelIcon />}
                            onClick={() => setConfirmCancelOpen(true)}>
                            Avboka
                        </LoadingButton>
                    </div>}
                    <div>
                        <h4 className='s4g-player-name'>{`${player.name} ${player.isGuest ? '(Gäst)' : ''} ${player.status === 2 ? '(Reserv)' : ''}`}</h4>
                    </div>
                </div>
                <div className='s4g-player-form-input-66'>
                    <div className='s4g-control-50'>
                        <TextField required id="s4g-p-handicap" label="HCP" sx={{ width: '100%;' }}
                            value={player.handicap || ''} onChange={e => updatePlayer({ ...player, handicap: e.target.value })} />
                    </div>
                    <div className='s4g-control-50'>
                        <FormControl sx={{ width: '100%;' }}>
                            <InputLabel id="s4g-p-tee-type-label">Tee *</InputLabel>
                            <Select labelId="s4g-p-tee-type-label" id="s4g-tee-type-select" value={player.teeType} label="Tee *"
                                onChange={e => updatePlayer({ ...player, teeType: e.target.value })} >
                                <MenuItem value='' disabled>Välj tee...</MenuItem>
                                <MenuItem value='Herre gul tee'>Herre gul tee</MenuItem>
                                <MenuItem value='Herre röd tee'>Herre röd tee (över 70 år)</MenuItem>
                                {isBlueTeeAvailable && <MenuItem value='Herre blå tee'>Herre blå tee</MenuItem>}
                                <MenuItem value='Dam röd tee'>Dam röd tee</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    {transportEnabled === true && <div className='s4g-control-50' style={{ paddingTop: '7px', marginBottom: '-7px' }} >
                        <FormControlLabel control={
                            <Checkbox
                                disabled={transportFull}
                                checked={player.requestTransport}
                                onChange={e =>
                                    updatePlayer({ ...player, requestTransport: e.target.checked })}
                            />}
                            label={transportFull === true ? "Tävlingskujts fullbokad" : "Önskar skjuts till tävlingen"}
                        />
                    </div>}
                </div>
            </div>
            <ConfirmDialog
                open={confirmCancelOpen}
                name={player.name}
                confirm={() => cancelRegistration()}
                close={() => setConfirmCancelOpen(false)}
            />
        </div>
    );
}

export default PlayerForm;
